<div *ngIf="active">
	<!-- Projects contents of active TabItem  -->
	<ng-content></ng-content>
</div>
